
import request from '@/utils/request'

export function getNavigationList(data) {
    return request({
      url: '/api/official/Navigation/list',
      method: 'GET',
    })
}
export function getConfigData(data) {
  return request({
    url: '/api/official/CustomizePage/footer',
    method: 'GET',
  })
}



// export function getStoresList(data) {
//     return request({
//       url: '/api/official/Stores/page',
//       method: 'POST',
//       data
//     })
// }
export function getStoresList(data) {
  return request({
    url: '/api/official/Stores/pageV2',
    method: 'POST',
    data
  })
}



export function getSpuList(data) {
  return request({
    url: '/api/official/Spu/page',
    method: 'POST',
    data
  })
}
// 分类商品
export function getCategorySpu(data) {
    return request({
      url: '/api/official/Spu/byCategory?'+data,
      method: 'GET',
      
    })
}
// 分类列表
export function getCategoryList(data) {
  return request({
    url: '/api/official/Category/list',
    method: 'GET',
    
  })
}
//商品详情
export function getSpuDetail(data) {
  return request({
    url: '/api/official/Spu/detail?'+data,
    method: 'GET',
    
  })
}

// 装修页面
export function getPageList(data) {
  return request({
    url: '/api/official/CustomizePage/page',
    method: 'POST',
    data,
  })
}
export function getPage(data) {
  return request({
    url: '/api/official/CustomizePage/detail?'+data,
    method: 'GET',
    
  })
}

export function getPageHome(data) {
  return request({
    url: '/api/official/CustomizePage/home?'+data,
    method: 'GET',
    
  })
}
export function getPageWxHome(data) {
  return request({
    url: '/api/official/CustomizePage/wxOpenHome?'+data,
    method: 'GET',
    
  })
}



// 质保查询
export function queryByBarcode(data) {
  return request({
    url: '/api/official/Install/queryByBarcode?'+data,
    method: 'GET',
    
  })
}

export function queryByPhone(data) {
  return request({
    url: '/api/official/Install/queryByPhoneAndLicense?'+data,
    method: 'GET',
    
  })
}
